import React, { Component } from 'react'
import { connect } from 'react-redux'
import PatientConfirm from './PatientConfirm'
import {
  Row,
  Col,
} from '@sketchpixy/rubix'

class Patient extends Component {
  constructor (props) {
    super(props)
    this.state = {
      patient: props.location.state,
      doneDisability: props.location.doneDisability
    }
  }

  render () {
    return (
      <div className={'home-containers'} >
        <Row style={{marginBottom:'20px', marginTop:'-30px'}}>
          <Col xs={8} className={'col-md-offset-1'} >
            <h2 className='heading-main' >
              {/* <strong>Your Patient</strong> */}
            </h2>
          </Col>
          <Col xs={3} >
          
          </Col>
        </Row>
        <PatientConfirm {...this.props} doneDisability={this.state.doneDisability} patient={this.state.patient}/>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps =
  ({
     login: {
       role
     }
   }) => ({
    role
  })

export default connect(mapStateToProps, mapDispatchToProps)(Patient)
